//desktop sticky navbar onscrollDown effect
let scrollCache = 0;
let isPinned = false;
const tabsWrapper = document.querySelector(".dossierHeader__tabsWrapper");
const header = document.querySelector(".mainNav");
const sectionHeight = document.querySelector(".mainNav__section")?.offsetHeight ?? 0;
const subSectionHeight = document.querySelector(".mainNav__subSection")?.offsetHeight ?? 0;
const navHeight = sectionHeight+subSectionHeight+1;
if (subSectionHeight===0) {
    tabsWrapper.classList.add("dossierHeader__tabsWrapper--noSubSection");
}
if (header) {
    const observer = new IntersectionObserver(([e]) => {
        isPinned = e.intersectionRatio < 1;
    },
    {   rootMargin: "-"+navHeight+"px 0px 0px 0px",threshold: [1] });

    observer.observe(tabsWrapper);
    window.addEventListener("scroll",()=>{
        const scrolled = window.scrollY;
        if (!isPinned) {
            tabsWrapper.classList.remove("dossierHeader__tabsWrapper--sticky");
            return;
        }
        else tabsWrapper.classList.add("dossierHeader__tabsWrapper--sticky");
        if(scrollCache > scrolled) {
            scrollCache = scrolled;
            tabsWrapper.classList.remove("dossierHeader__tabsWrapper--top");
            header.style.top = "0";
        }else{
            scrollCache = scrolled;
            tabsWrapper.classList.add("dossierHeader__tabsWrapper--top");
            header.style.top = "-92px";
        }
    });
}

// share button class for header
const footer = document.querySelector(".dossierHeader__footer");
document.querySelector("#dossier-shareButton").addEventListener("click", () => {
    footer.classList.toggle("dossierHeader__footer--datesOpen");
});

// remove anchor from url
document.addEventListener("readystatechange", event => {
    if (event.target.readyState === "complete") {
        let currentUrl = window.location.href;
        currentUrl = currentUrl.replace("#topAnchor", "");
        window.history.pushState({}, null, currentUrl);
    }
});
